:host {
  display: block;
}

.spw-search-field {
  position: relative;
}

.spw-search-field__options {
  position: absolute;
  width: 100%;
  background-color: #fff;
  border: 1px solid var(--spw-color-themes-grey-grey-800);
  border-radius: 0 0 4px 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 44;
  margin-top: -2px;
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}

.spw-search-field__options--down {
  top: 100%;
  transform: translateY(0);
}

.spw-search-field__options--up {
  top: 100%;
  transform: translateY(0);
}

.spw-search-field__option {
  padding: 12px;
  border-bottom: 1px solid var(--spw-color-themes-grey-grey-900);
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--spw-color-themes-grey-grey-200);
  }

  &:last-child {
    border-bottom: none;
  }

  &--focused {
    background-color: var(--spw-color-themes-grey-grey-300);
  }

  &--selected {
    font-weight: 700;
  }
}

.spw-search-field__no-results {
  padding: 12px;
  cursor: not-allowed;
  color: var(--spw-color-themes-grey-grey-600);
}
